<template>
  <div class="testimonial-carousel">
    <transition name="fade" mode="out-in">
      <div class="testimonial" :key="currentTestimonialIndex">
        <p class="testimonial-text">"{{ currentTestimonial.text }}"</p>
        <p class="testimonial-author">– {{ currentTestimonial.author }}</p>
      </div>
    </transition>
    <div class="carousel-controls">
      <button @click="prevTestimonial" class="carousel-button" aria-label="Previous testimonial">‹</button>
      <button @click="nextTestimonial" class="carousel-button" aria-label="Next testimonial">›</button>
    </div>
    <div class="carousel-indicators" role="tablist">
      <span
          v-for="(testimonial, index) in testimonials"
          :key="index"
          :class="{ active: index === currentTestimonialIndex }"
          @click="goToTestimonial(index)"
          :aria-label="`Go to testimonial ${index + 1}`"
          :aria-selected="index === currentTestimonialIndex"
          role="tab"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestimonialCarousel',
  data() {
    return {
      testimonials: [
        {
          text: "I didn’t even know what I was sending — and it was perfect. Somehow weird, sweet, and totally us.",
          author: "Someone in love"
        },
        {
          text: "I was skeptical. AI postcards? Really? But then it arrived — and damn, it kinda nailed it.",
          author: "Former Doubter (Now Kinda Into It)"
        },
        {
          text: "I sent one to my sister. She cried. I cried. We’re weird criers, okay?",
          author: "Certified Emotion-Haver"
        },
        {
          text: "Felt like magic. Like I had help saying something I didn’t quite know how to say.",
          author: "A grateful romantic"
        },
        {
          text: "Honestly? It’s fun. Weirdly fun. I’d do it again.",
          author: "Someone who vibes"
        },
        {
          text: "I didn’t write the words. But I meant every one of them.",
          author: "Postcard Sender #37"
        }
      ],
      currentTestimonialIndex: 0,
      intervalId: null
    };
  },
  computed: {
    currentTestimonial() {
      return this.testimonials[this.currentTestimonialIndex];
    }
  },
  methods: {
    nextTestimonial() {
      this.currentTestimonialIndex = (this.currentTestimonialIndex + 1) % this.testimonials.length;
    },
    prevTestimonial() {
      this.currentTestimonialIndex = (this.currentTestimonialIndex - 1 + this.testimonials.length) % this.testimonials.length;
    },
    goToTestimonial(index) {
      this.currentTestimonialIndex = index;
    },
    startCarousel() {
      this.intervalId = setInterval(() => {
        this.nextTestimonial();
      }, 5000);
    },
    stopCarousel() {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
  mounted() {
    this.startCarousel();
  },
  beforeUnmount() {
    this.stopCarousel();
  }
};
</script>

<style scoped>
.testimonial-carousel {
  position: relative;
  text-align: center;
  padding: 40px 20px;
  margin: 40px auto;
  background-color: var(--light-pink);
  border-left: 4px solid var(--violet-lush);
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  max-width: 800px;
}

.testimonial {
  padding: 20px;
}

.testimonial-text {
  font-size: 1.1rem;
  line-height: 1.7;
  color: var(--rich-black);
  margin-bottom: 10px;
}

.testimonial-author {
  font-weight: 600;
  font-size: 1rem;
  color: var(--violet-lush);
}

.carousel-controls {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.carousel-button {
  background: none;
  border: none;
  font-size: 2.5rem;
  cursor: pointer;
  color: var(--hollywood-cerise);
  transition: color 0.3s ease;
}

.carousel-button:hover {
  color: var(--violet-lush);
}

.carousel-indicators {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.carousel-indicators span {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin: 0 6px;
  background-color: #ddd;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.carousel-indicators span:hover {
  background-color: var(--powder-blue);
}

.carousel-indicators span.active {
  background-color: var(--hollywood-cerise);
}

/* Transition styles */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Responsive */
@media (max-width: 600px) {
  .testimonial-carousel {
    padding: 30px 16px;
  }
  .testimonial-text {
    font-size: 1rem;
  }
  .carousel-button {
    font-size: 2rem;
  }
}
</style>
